import { FaShoppingCart, FaUsers, FaChartLine, FaShieldAlt, FaLightbulb, FaLanguage } from "react-icons/fa";

export default function Section8() {
    const benefits = [
        {
            title: "Boosts sales and leads without extra ad costs",
            icon: <FaShoppingCart className="text-5xl mb-4 mx-auto" />
        },
        {
            title: "Improves user experience for local audiences",
            icon: <FaUsers className="text-5xl mb-4 mx-auto" />
        },
        {
            title: "Reduces bounce rates and cart abandonment",
            icon: <FaChartLine className="text-5xl mb-4 mx-auto" />
        },
        {
            title: "Builds trust and brand credibility",
            icon: <FaShieldAlt className="text-5xl mb-4 mx-auto" />
        },
        {
            title: "Gives you valuable insights into customer behavior",
            icon: <FaLightbulb className="text-5xl mb-4 mx-auto" />
        },
        {
            title: "Adapts your website for both Arabic and English users",
            icon: <FaLanguage className="text-5xl mb-4 mx-auto" />
        }
    ];

    return (
        <div className="SectionCRO py-[25px] md:py-[50px] bg-[#f9f9f9]">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Why CRO Matters for UAE Businesses
                </h2>
                <p className="mt-4 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    CRO is one of the most cost-effective ways to grow your business. Instead of spending more to attract new visitors, we help you convert the ones you already have. In the UAE, where customers expect convenience and trust, an optimized website is a powerful competitive advantage.<br />
                <br />
                <b>Here’s how CRO benefits your business:</b>

                </p>
            </div>

            {/* Benefits Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {benefits.map((benefit, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-center transition flex flex-col items-center ${index % 2 === 0
                            ? "bg-[#E42E35] text-white"
                            : "bg-white text-[#151515]"
                            }`}
                    >
                        {benefit.icon}
                        <p className="text-[16px] md:text-[17px] leading-[22px] font-semibold mt-2">
                            {benefit.title}
                        </p>
                    </div>
                ))}
            </div>

            {/* Summary */}
            <div className="text-center mt-12 max-w-2xl mx-auto">
                <p className="text-[#151515] text-[16px] md:text-[18px] font-semibold">
                    In the UAE, where customers expect convenience and trust, an optimized website is a powerful competitive advantage.
                </p>
            </div>
        </div>
    );
}
